import React from "react";

function Canvas_Clipping() {
  return (
    <div>
      <h1>Canvas_Clipping Component</h1>
      <p>This is the Canvas Clipping tutorial page content.</p>
    </div>
  );
}

export default Canvas_Clipping;
